module.exports = __webpack_public_path__ + "static/img/icon_video@2x.1a022c39.png";